export default __webpack_public_path__ + "static/media/business-1.ffa3fa50.jpg";